import { environment } from './environment';

const baseUrl = environment.apiUrl;

export const endpoints = {
  dashboard: `${baseUrl}/dashboard`,
  dashboardFaturas: `${baseUrl}/dashboard/faturas`,
  beneficiario: `${baseUrl}/beneficiario`,
  contrato: `${baseUrl}/contrato`,
  contratoGrauDeParentesco: `${baseUrl}/contratoGrauDeParentesco`,
  contratoProdutoEstruturaOrganizacional: `${baseUrl}/contratoProdutoEstruturaOrganizacional`,
  contratoProdutoTabelaDePreco: `${baseUrl}/contratoProdutoTabelaDePreco`,
  documento: `${baseUrl}/documento`,
  documentoBeneficiario: `${baseUrl}/documentoBeneficiario`,
  esqueceuSenha: `${baseUrl}/esqueceuSenha`,
  redefinicaoSenha: `${baseUrl}/redefinicaoSenha`,
  credencialRpa: `${baseUrl}/credencialRpa`,
  estadoCivil: `${baseUrl}/estadoCivil`,
  estruturaOrganizacional: `${baseUrl}/estruturaOrganizacional`,
  faixaDePreco: `${baseUrl}/faixaDePreco`,
  funcionario: `${baseUrl}/funcionario`,
  grauDeParentesco: `${baseUrl}/grauDeParentesco`,
  login: `${baseUrl}/login`,
  logout: `${baseUrl}/logout`,
  logRequisicaoIntegracaoOrquestrador: `${baseUrl}/logRequisicaoIntegracaoOrquestrador`,
  motivoDeBloqueio: `${baseUrl}/motivoDeBloqueio`,
  motivoDeDesligamento: `${baseUrl}/motivoDeDesligamento`,
  movimentacaoCadastral: `${baseUrl}/movimentacao-cadastral`,
  onboarding: `${baseUrl}/onboarding`,
  produto: `${baseUrl}/produto`,
  produtoBeneficiario: `${baseUrl}/produtoBeneficiario`,
  provedor: `${baseUrl}/provedor`,
  exportacaoLayoutProvedor: `${baseUrl}/exportacao-layout-provedor`,
  provedorGeral: `${baseUrl}/provedorGeral`,
  provedorGrauDeParentescoDocumento: `${baseUrl}/provedorGrauDeParentescoDocumento`,
  responsavelRecursoHumano: `${baseUrl}/responsavelRecursoHumano`,
  tabelaDePreco: `${baseUrl}/tabelaDePreco`,
  usuarios: `${baseUrl}/usuario`,
  companhia: `${baseUrl}/companhia`,
  empresa: `${baseUrl}/empresa`,
  servicoNotificacao: `${baseUrl}/servicoNotificacao`,
  logGeral: `${baseUrl}/logGeral`,
  portalDoCliente: `${baseUrl}/portalDoCliente`,
  portalDoClienteImagem: `${baseUrl}/portalDoClienteImagem`,
  portalDoClienteLinkCabecalho: `${baseUrl}/portalDoClienteLinkCabecalho`,
  portalDoClienteTopicoPerguntaFrequente: `${baseUrl}/portalDoClienteTopicoPerguntaFrequente`,
  portalDoClientePerguntaFrequente: `${baseUrl}/portalDoClientePerguntaFrequente`,
  portalDoClienteCategoriaOcorrencia: `${baseUrl}/portalDoClienteCategoriaOcorrencia`,
  portalDoClienteOcorrencia: `${baseUrl}/portalDoClienteOcorrencia`,
  regraContratoFood: `${baseUrl}/regraContratoAlimentacaoRefeicao`,
  regraContratoSaudeOdontologico: `${baseUrl}/regraContratoSaudeOdontologico`,
  cabecalhoPedidoDeCarga: `${baseUrl}/cabecalhoPedidoDeCarga`,
  itensCabecalhoPedidoDeCarga: `${baseUrl}/itensCabecalhoPedidoDeCarga`,
  filaIntegracoes: `${baseUrl}/fila-integracoes`,
  portalDoClienteAtendimento: `${baseUrl}/portalDoClienteAtendimento`,
  cabecalhoConferenciaDeFatura: `${baseUrl}/cabecalhoConferenciaDeFatura`,
  detalheCabecalhoConferenciaDeFatura: `${baseUrl}/detalheCabecalhoConferenciaDeFatura`,
  consultaTabelaDePreco: `${baseUrl}/consultaTabelaDePreco`,
  criticaConferenciaDeFatura: `${baseUrl}/criticaConferenciaDeFatura`,
  criticaSolucaoDetalheCabecalhoConferenciaDeFatura: `${baseUrl}/criticaSolucaoDetalheCabecalhoConferenciaDeFatura`,
  solucaoConferenciaDeFatura: `${baseUrl}/solucaoConferenciaDeFatura`,
  movimentacaoCadastralManualProvedor: `${baseUrl}/movimentacaoCadastralManualProvedor`,
  lancamentoDebitoECreditoDeFatura: `${baseUrl}/lancamentoDebitoECreditoDeFatura`,
  rubricaProvedorConciliacaoDeFatura: `${baseUrl}/rubricaProvedorConciliacaoDeFatura`,
  layoutBatimentoFatura: `${baseUrl}/layoutBatimentoFatura`,
  remetenteLeitorEmail: `${baseUrl}/remetenteLeitorEmail`,
  chatIa: `${baseUrl}/chatIa`,
  integracaoHapvidaStatusJob: `${baseUrl}/integracao-hapvida-status`,
  integracaoHapvidaIniciarJob: `${baseUrl}/integracao-hapvida-iniciar-job`,
};
